import { CommentFill, Envelope } from '@gravity-ui/icons';
import { SignInIdentifier } from '@logto/schemas';
import { useState } from 'react';

import type { VerificationCodeIdentifier } from '@/types';

import MethodSwitchButton from './MethodSwitchButton';
import useVerificationCodeLink from './use-verification-code-link';

type Props = {
  readonly className?: string;
  readonly identifier: VerificationCodeIdentifier;
  readonly value: string;
};

const VerificationCodeLink = ({ className, identifier, value }: Props) => {
  const onSubmitHandler = useVerificationCodeLink();
  const [isSending, setIsSending] = useState(false);

  return (
    <MethodSwitchButton
      className={className}
      icon={identifier === SignInIdentifier.Phone ? <CommentFill /> : <Envelope />}
      text="action.sign_in_via_passcode"
      isLoading={isSending}
      onClick={async () => {
        setIsSending(true);
        try {
          await onSubmitHandler({ identifier, value });
        } finally {
          setIsSending(false);
        }
      }}
    />
  );
};

export default VerificationCodeLink;
